// John Eldhose 20180816
import { RestfulPost } from './Restful';

export async function addContact(data) {
  const cont = await RestfulPost('addContact', {data: data}, (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return cont;
}



// WEBPACK FOOTER //
// ./src/Api/addContact.js